module.exports = __webpack_public_path__ + "img/avatar4.f585af3c.png";